import { useMemo } from 'react';
import { getPopularQuestionsForUser, getRandomElements } from '../../utils/quickAnswerUtils';
import { getGatesAndScopes } from '../../selectors/gatesSelector';
import { useSelector } from 'react-redux';
import useUpdateSearch from '../../hooks/useUpdateSearch';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { useAnalyticsPermissions } from '../../utils/useAnalyticsPermissions';
import { Button } from 'foundations-components/transitional/components/Button';
// @ts-expect-error Untyped import
import { selectGenerativeAIEnabled } from '../../selectors/aiSettingsSelector';
import { getQuestionCopy } from '../../constants/quickAnswerQuestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SearchSuggestions = () => {
  const {
    updateAndRecordSearch
  } = useUpdateSearch();
  const analyticsPermissions = useAnalyticsPermissions();
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const hasAiSearchSettingsEnabled = useSelector(selectGenerativeAIEnabled);
  const handleClickSuggestion = question => {
    trackEvent(EVENTS.clickSuggestedSearch, {
      filterValue: question
    });
    updateAndRecordSearch(getQuestionCopy(question));
  };
  const questions = useMemo(() => {
    const popularQuestions = getPopularQuestionsForUser(gates, scopes, analyticsPermissions);
    return getRandomElements(popularQuestions, 3);
  }, [analyticsPermissions, gates, scopes]);
  const QuestionList = /*#__PURE__*/_jsx(_Fragment, {
    children: questions.map((question, index) => /*#__PURE__*/_jsx(Button, {
      marginInlineStart: "0",
      "data-test-id": `suggested-search-${index}`,
      onClick: () => {
        handleClickSuggestion(question.questionId);
      },
      size: "small",
      use: "tertiary-light",
      children: getQuestionCopy(question.questionId)
    }, question.questionId))
  });
  if (questions.length > 0 && hasAiSearchSettingsEnabled) {
    return /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-100",
        as: "h2",
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.globalSearch.suggestedSearch.heading"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.globalSearch.suggestedSearch.subheading"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        gap: "400",
        justifyContent: "start",
        flexWrap: "wrap",
        inlineSize: "100%",
        marginBlockStart: "400",
        children: QuestionList
      })]
    });
  }
};
export default SearchSuggestions;